export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zkontrolovat adresu"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte adresu"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte blockchain"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Provést kontrolu"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nízké riziko"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Střední riziko"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vysoké riziko"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Není na černé listině"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zkontrolovat jinou adresu"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stáhnout PDF"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zpět"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte poskytovatele"])}
}